module.exports = __webpack_public_path__ + "static/hyperarvin-cover-95e28a22582835e3546ef6e61f629ae0.jpg";